var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCutBrand = function SvgCutBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 6.247 12.553 5.2L41.753 24l-5.2 12.553L24 41.753l-12.553-5.2L6.247 24l5.2-12.553zM24 3 9.151 9.151 3 24l6.151 14.85L24 45l14.849-6.15L45 24 38.849 9.151z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 33.09h-3.608V14.01h8.61a6.4 6.4 0 0 1 2.351.411A4.76 4.76 0 0 1 30.4 15.61a5.5 5.5 0 0 1 1.121 1.872 7.1 7.1 0 0 1 .4 2.433 6.27 6.27 0 0 1-.889 3.389 4.84 4.84 0 0 1-2.665 2.023l3.909 7.763H28.25l-3.55-7.353h-3.42Zm4.647-10.39a2.3 2.3 0 0 0 1.64-.561 2.08 2.08 0 0 0 .6-1.6v-1.253a2.04 2.04 0 0 0-.6-1.585 2.35 2.35 0 0 0-1.64-.547H21.28V22.7Z"
  })));
};
export default SvgCutBrand;